import { render, staticRenderFns } from "./ServicesReservationAddedServiceFloatBtns.vue?vue&type=template&id=4cb9e226&"
import script from "./ServicesReservationAddedServiceFloatBtns.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports